import axios from "axios";
import { fetchBaseProxyUrl } from "core/utils/common";

const baseURL = fetchBaseProxyUrl({port: 8083});

/**
 * Gets the token for a logged in user
 * @param email 
 * @returns 
 */
export const tokenService = async () => {
  const response: any = await axios.request({
    method: 'GET',
    url: `${baseURL}/auth/token`,
    withCredentials: true
  });
  const data = response.data;
  return(data)
}

/**
 * Gets the IDP user data for a logged in user 
 * @returns 
 */
export const assertionService = async () => {
  const response: any = await axios.request({
    method: 'GET',
    url: `${baseURL}/saml/assertion`,
    withCredentials: true
  });
  const data = response.data;
  return(response)
}

/**
 * Redirects users to the login IDP
 */
export const loginService = async () => {
  localStorage.removeItem('accessDenied');
  window.location.href = `${baseURL}/saml/login`;
  return null;
}

/**
 * Logsout users from the login IDP and redirects them back
 */
export const logoutService = async () => {
  localStorage.setItem('accessDenied', 'true');
  window.location.href = `${baseURL}/saml/logout`;
  return null;
}